var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7729 9.89798L7.14792 15.523C7.09565 15.5752 7.03361 15.6167 6.96533 15.645C6.89704 15.6733 6.82386 15.6878 6.74995 15.6878C6.67604 15.6878 6.60285 15.6733 6.53457 15.645C6.46628 15.6167 6.40424 15.5752 6.35198 15.523C6.29972 15.4707 6.25826 15.4087 6.22998 15.3404C6.20169 15.2721 6.18713 15.1989 6.18713 15.125C6.18713 15.0511 6.20169 14.9779 6.22998 14.9096C6.25826 14.8413 6.29972 14.7793 6.35198 14.727L11.5797 9.50001L6.35198 4.27298C6.24643 4.16743 6.18713 4.02427 6.18713 3.87501C6.18713 3.72574 6.24643 3.58259 6.35198 3.47704C6.45753 3.37149 6.60068 3.31219 6.74995 3.31219C6.89921 3.31219 7.04237 3.37149 7.14792 3.47704L12.7729 9.10204C12.8252 9.15428 12.8667 9.21632 12.895 9.2846C12.9233 9.35289 12.9379 9.42609 12.9379 9.50001C12.9379 9.57393 12.9233 9.64713 12.895 9.71541C12.8667 9.7837 12.8252 9.84574 12.7729 9.89798Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRight);
export default __webpack_public_path__ + "static/media/icon-right.d16a80325b6a79123629f89ab59b002d.svg";
export { ForwardRef as ReactComponent };